

import { replaceBucketKeysWithUrls } from '@shootsta/client-aws-s3';
import {
  getDataWithOrganisationId,
  getDataWithoutOrganisationId } from
'../../utils';


const appendOrganisation = (data, getOrganisationId) => getOrganisationId ?
getDataWithOrganisationId(data, getOrganisationId) :
data;

const removeOrganisation = (data, getOrganisationId) => getOrganisationId ?
getDataWithoutOrganisationId(data) :
data;

export const processDataBucketKeysReplacement = async ({
  apiClient,
  data,
  organisationId,
  getOrganisationId,
  substitutedKeys
}) => {
  const dataWithOrganisation = appendOrganisation(data, getOrganisationId);

  const dataWithReplacedKeys = await replaceBucketKeysWithUrls({
    apiClient,
    data: dataWithOrganisation,
    organisationId,
    substitutedKeys
  });

  return removeOrganisation(dataWithReplacedKeys, getOrganisationId);
};